import { FormFieldJson, FormInputJson, TableColumnJson } from '@doss/common-all'
import { Typography } from '@mui/material'
import { tss } from 'tss-react/mui'
import { Tooltip } from '~/components/ui/atoms/tooltip/Tooltip'

interface ConditionExpressionColumnChipProps {
  name: string
  value: TableColumnJson | FormFieldJson | FormInputJson
}

export function ConditionExpressionColumnChip({ name, value }: ConditionExpressionColumnChipProps) {
  const { classes } = useStyles()

  let tooltipText
  if ('table' in value && value.table?.name) {
    tooltipText = `${value.table.name}: "${name}"`
  } else {
    tooltipText = `Form: "${name}"`
  }

  return (
    <div className={classes.chip}>
      <Tooltip arrow placement="top" title={tooltipText}>
        <Typography variant="body1">{name}</Typography>
      </Tooltip>
    </div>
  )
}

const useStyles = tss.create(({ theme }) => ({
  chip: {
    backgroundColor: theme.palette.common.doss.blue[2],
    borderRadius: '2px',
    padding: theme.spacing(0),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '2px',
    whiteSpace: 'nowrap',
  },
}))
